import { User } from "oidc-client-ts";
import { authConfig, STORAGE_PREFIX } from "./authConfig";

export const getToken = () => {
  const { authority, client_id } = authConfig;

  const userStorage = localStorage.getItem(`${STORAGE_PREFIX}user:${authority}:${client_id}`);
  if (!userStorage) return null;

  const user = User.fromStorageString(userStorage);
  if (user.expired) return null;

  return user.access_token;
};
